import { Leaf, Sparkles } from 'lucide-react'
import { Button } from '@/components/ui/button'

export type FirstProjectProps = {
  onCreateTemplate: () => void
  onExploreDashboard: () => void
}

export function FirstProject({ onCreateTemplate, onExploreDashboard }: FirstProjectProps) {
  return (
    <div className="max-w-md mx-auto w-full">
      <div className="flex items-center justify-center mb-6">
        <div className="flex items-center space-x-2">
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-green-400 to-blue-500 shadow-sm">
            <Leaf className="h-5 w-5 text-white" />
          </div>
          <div className="flex flex-col">
            <span className="font-bold text-green-700 text-lg leading-tight">SustainTrack</span>
            <span className="text-xs text-green-600 leading-tight">Premier projet</span>
          </div>
        </div>
      </div>

      <div className="space-y-4 bg-white/70 backdrop-blur-sm p-6 rounded-lg border shadow">
        <div>
          <h2 className="text-base font-semibold">Par où commencer ?</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Vous pouvez créer votre premier template de collecte tout de suite, ou explorer
            le dashboard et démarrer plus tard.
          </p>
        </div>

        <div className="flex flex-col gap-2">
          <Button
            type="button"
            className="w-full bg-green-600 hover:bg-green-700"
            onClick={onCreateTemplate}
          >
            <Sparkles className="h-4 w-4 mr-2" />
            Créer un template
          </Button>
          <Button
            type="button"
            variant="outline"
            className="w-full"
            onClick={onExploreDashboard}
          >
            Explorer le dashboard
          </Button>
        </div>
      </div>
    </div>
  )
}
